document.addEventListener("DOMContentLoaded", () => {

  let selectedBundle = null;
  let selectedItems = [];
  let isRedirecting = false;

  const statusBox = document.getElementById("bundle-status");

  const allProductsData = JSON.parse(
    document.getElementById("all-products-data")?.textContent || "[]"
  );

  // =====================
  // 🟢 STATUS UPDATE
  // =====================
  function updateStatus() {

    if (!statusBox) return;

    if (!selectedBundle) {
      statusBox.innerText = "Select a bundle to start";
      return;
    }

    if (selectedBundle === "1") {
      statusBox.innerText = `Select 1 product (${selectedItems.length}/1)`;
    }

    if (selectedBundle === "3") {
      statusBox.innerText = `Select 3 products (${selectedItems.length}/3)`;
    }

    if (selectedBundle === "all") {
      statusBox.innerText = `Adding all products...`;
    }
  }

  // =====================
  // 🟢 BUNDLE SELECT
  // =====================
  document.querySelectorAll(".bundle-checkbox").forEach(cb => {

    cb.addEventListener("change", async function () {

      document.querySelectorAll(".bundle-checkbox").forEach(o => {
        if (o !== this) o.checked = false;
      });

      selectedBundle = this.value;
      selectedItems = [];

      updateStatus();

      // 🔥 ALL → add + checkout
      if (selectedBundle === "all") {
        await checkoutAll();
      }

    });

  });

  // =====================
  // 🟢 TRACK ADD TO CART
  // =====================
  document.addEventListener("submit", function (e) {

    const form = e.target;

    if (!form.matches('form[action="/cart/add"]')) return;
    if (!selectedBundle || isRedirecting) return;

    const formData = new FormData(form);
    const variantId = String(formData.get("id"));

    if (!variantId) return;

    // prevent duplicate tracking
    if (!selectedItems.includes(variantId)) {
      selectedItems.push(variantId);
    }

    updateStatus();

    // =====================
    // AUTO CHECKOUT
    // =====================
    if (selectedBundle === "1" && selectedItems.length === 1) {
      triggerCheckout();
    }

    if (selectedBundle === "3" && selectedItems.length === 3) {
      triggerCheckout();
    }

  });

  // =====================
  // 🚀 CHECKOUT REDIRECT
  // =====================
  function triggerCheckout() {

    if (isRedirecting) return;

    isRedirecting = true;

    if (statusBox) statusBox.innerText = "Redirecting to checkout...";

    // wait for Shopify cart update
    setTimeout(() => {
      window.location.href = "/checkout";
    }, 1000);

  }

  // =====================
  // 🔥 ALL PRODUCTS FLOW
  // =====================
  async function checkoutAll() {

    try {

      if (!allProductsData.length) {
        alert("No products found");
        return;
      }

      if (statusBox) statusBox.innerText = "Adding all products...";

      const items = allProductsData.map(p => ({
        id: p.id,
        quantity: 1
      }));

      // 🔥 clear cart
      await fetch('/cart/clear.js');

      // 🔥 add all
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        throw new Error("Cart add failed");
      }

      await res.json(); // ensure complete

      // 🔥 delay (Shopify sync fix)
      setTimeout(() => {
        window.location.href = "/checkout";
      }, 600);

    } catch (err) {
      console.error(err);
      alert("Error adding products");
    }
  }

});